import React, { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';

import Header from 'components/Header/Header';
import Footer from 'components/Footer/Footer';

import ScrollToTopOnMount from 'shared/ScrollToTopOnMount';

import homeStyle from '../Home/Home.module.scss';

const DEFAULT_FOOTER_COLOR = '#060606';

const WithHeaderAndFooter = ({ ...props }) => {
    const [width, setwidth] = useState(window.innerWidth);
    let currentUserScrollHack = window.pageYOffset;

    const onScroll = throttle(() => {
        if (width > 768) {
            const currentScrollPos = window.pageYOffset;
            const navbar = document.getElementById('navbar');
            const mask = document.getElementById('mask');
            const logo = document.getElementById('logo');
            const logo_small = document.getElementById('logo_small');
            const user_name = document.getElementById('user_name');
            const urs = document.getElementById('urs');
            Object.assign(logo.style, {
                opacity: Math.max(0, 1 - currentScrollPos / 70),
            });
            Object.assign(navbar.style, {
                top: `${Math.max(
                    width < 1024 ? -21 : -42,
                    0 - currentScrollPos / 3
                )}px`,
            });
            Object.assign(user_name.style, {
                top: `${Math.max(-32, 0 - currentScrollPos / 6)}px`,
                opacity: Math.max(0, 1 - currentScrollPos / 70),
            });
            Object.assign(urs.style, {
                top: `${Math.max(-12, 0 - currentScrollPos / 20)}px`,
            });
            Object.assign(mask.style, {
                top: `${Math.min(0, currentScrollPos / 3 - 56)}px`,
            });
            Object.assign(logo_small.style, {
                top: `${Math.min(6, currentScrollPos / 2.5 - 110)}px`,
            });
        }
    }, 50);

    const onTouchMove = throttle(() => {
        const currentScrollPos = window.pageYOffset;
        const navbar = document.getElementById('navbar');
        const mobile_nav = document.getElementById('mobile_nav');
        if (currentUserScrollHack > currentScrollPos) {
            Object.assign(navbar.style, {
                top: `0px`,
            });
            Object.assign(mobile_nav.style, {
                bottom: `0px`,
            });
        }

        if (currentUserScrollHack < currentScrollPos) {
            Object.assign(navbar.style, {
                top: `-62px`,
            });
            Object.assign(mobile_nav.style, {
                bottom: `-62px`,
            });
        }
        currentUserScrollHack = currentScrollPos;
    }, 50);

    const displayWindowSize = () => {
        setwidth(window.innerWidth);
        if (props.wrapperSetWidth) {
            props.wrapperSetWidth(window.innerWidth);
        }
    };

    useEffect(() => {
        window.addEventListener('resize', displayWindowSize);
        window.addEventListener('scroll', onScroll);
        window.addEventListener('touchmove', onTouchMove);

        return () => {
            window.removeEventListener('resize', displayWindowSize);
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('touchmove', onTouchMove);
        };
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <ScrollToTopOnMount />
            <div id="mask" className={homeStyle.mask} />
            <Header user={props.userInfo} />
            {props.children}
            {props.noFooter ? null : (
                <FooterBackgroundWrapper background={props.footerBackground || DEFAULT_FOOTER_COLOR} />
            )}
        </>
    );
};

const FooterBackgroundWrapper = ({ background }) => {
    if (background) {
        return (
            <div style={{ background: background }}>
                <Footer />
            </div>
        );
    }

    return <Footer />;
};

export default WithHeaderAndFooter;
